<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <div class="message-box">
            <w-transition-fade>
                <w-alert
                    class="my0 text-light"
                    v-if="form.submitted"
                    success
                    no-border
                >
                    The form is valid, ready to send it!
                </w-alert>

                <w-alert
                    class="my0 text-light"
                    v-else-if="form.valid === false"
                    error
                    no-border
                >
                    Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                </w-alert>
            </w-transition-fade>
        </div>
     

        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title> Tambah Profil </template>
            <template #default>
                <w-form
                    ref="form"
                    v-model="dialog.valid"
                    @validate="submitProfil"
                    @success="success"
                >
                    <template></template><br />
                   <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                           <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            </div>

                           </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. KP/No. Syarikat *"  
                              name="No. ID" 
                              v-model="form_profil.no_id" 
                              :validators="[validators.required]"/>
                            <z-input 
                              label="Nama *" 
                              name="Nama" 
                              v-model="form_profil.nama" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Alamat" 
                              name="Alamat" 
                              v-model="form_profil.alamat1" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat2" 
                              v-model="form_profil.alamat2" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat3" 
                              v-model="form_profil.alamat3" />
                        </w-flex>
                        <z-lookup 
                              label="Poskod" 
                              name="poskod" 
                              :url='service_bil_pelbagai+"lookup/lkp_poskod"' 
                              :sort="false" :cache="false"
                              v-model="form_profil.lkp_poskod_id"/><br>
                            <w-flex justify-center align-center>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.negeri}}</td>
                                  </tr>
                              </div>
                            </w-flex><br>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. Telefon" 
                              name="No. Telefon" 
                              v-model="form_profil.no_tel" 
                              :validators="[validators.numeric]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Emel"  
                              name="Email" 
                              v-model="form_profil.emel"/>
                        </w-flex>
                </w-form>
            </template>
            <template #actions>
                <div class="spacer" />
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
                <w-button
                    class="ml1"
                    :loading="dialog.loading"
                    :disabled="dialog.valid === false"
                    @click="$refs.form.validate()"
                    >Simpan</w-button
                >
            </template>
        </w-dialog>

        <w-form
            class=""
            v-model="form.valid"
            v-model:errors-count="form.errorsCount"
            @validate="submitResit"
            @success="onSuccess"
        >
            <z-page title="Terimaan Tanpa Bil">
                <w-card bg-color="" class="">
                    <w-flex justify-center align-center >
                        <div class="xs6">
                           <w-input   v-model="form.no_rujukan" required label="No Rujukan *"   :validators="[validators.required]"  />
                        </div>

                        <div class="xs6">
                             <!-- <w-input   v-model="form.no_fail" required label="No Fail *"   :validators="[validators.required]"  /> -->
                        </div>
                    </w-flex>
                    <br>
                     <w-flex justify-center align-center >
                        <div class="xs6">
                            <!-- <z-input label="Tarikh Bayar *" name="tarikh_bayar" v-model="form.tarikh_bayar" 
                                  type="date" :validators="[validators.required]" /> -->
                        <template v-for="(d, index) in form.cara_bayaran" :key="index">
                            <z-input label="Tarikh Bayar" :model-value="form.tarikh_bayar" @update:modelValue="val => form.tarikh_bayar = val" type="date" :disabled="!d.lkp_cara_bayaran_id || Number(d.lkp_cara_bayaran_id) != 32"  :validators="[validators.required]"/>
                        </template>
                        </div>
                         <div class="xs6">
                            
                        </div>
                    </w-flex>
                    <w-flex class="mt3">
                        
                        <w-input   v-model="form.profil_keterangan" required label="Profil *"   :validators="[validators.required]" @click="profil" />
                        <div class="xs1"> 
                            <w-icon @click="profil">fal fa-search</w-icon>
                            &nbsp;
                            <w-icon @click="dialog.show = true">fal fa-plus</w-icon>
                        </div>
                    </w-flex>
                    <w-flex justify-center align-center v-if="form.profil_keterangan">
                        <div class="xs6">
                            <h5 class="fw-semibold m0">Profil :</h5>
                            <!-- {{form.no_id}}  {{form.nama}} -->
                            {{ form.profil_keterangan }}
                        </div>

                        <div class="xs6">
                            <h5 class="fw-semibold m0">Alamat :</h5>
                            {{ form.profil_alamat }} {{ form.poskod }}
                            {{ form.bandar }} {{ form.negeri }}
                        </div>
                    </w-flex>
                    
                    <w-flex justify-center align-center class="mt5">
                          <div class="w-card__content content-hardcode">                
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Akaun *</td>
                                        <td>Vot</td>
                                        <td>Butiran </td>
                                        <td>Amaun  (RM) *</td>
                                        <td> <w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="dt, index in form.butiran">
                                        <td >
                                            <!-- <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="dt.akaun_id" @pilih="Vot_akaun(dt)" :validators="[validators.required]" /> -->
                                             <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir_vot"' :sort="false" :cache="false" v-model="dt.akaun_id" @pilih="Vot_akaun(dt)" :validators="[validators.required]"/>
                                        </td>
                                        <td>
                                               <template v-if="dt.vot_id">
                                                    <template v-if="dt.ind_vot_id">
                                                       <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                                   </template>
                                                   <template v-else>
                                                       <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                                   </template>
                                               </template>
                                               <template v-else>
                                                   <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                               </template>

                                                
                                                
                                        </td>
                                        
                                        <td>
                                          <w-input  v-model="dt.keterangan" maxlength="255" /> 
                                        </td>
                                        <td>
                                            <z-money v-model:originalValue="dt.amaun" v-on:keyup="cekAmaun()" validators="[validators.required]"/> 
                                        </td>
                                        <td><w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon></td>
                                    </tr>
                                    <tr >
                                      <td colspan="3">Jumlah</td>
                                      <td align="right">{{$zutil.currency(form.amaun)}}</td>
                                      <td></td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                          </div>

                        </w-flex> 
                </w-card>
                <w-flex justify-center align-center class="mt5">
                    
                    <br>
                    <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Cara Bayaran</td>
                                    <td>Bank</td>
                                    <td>No Cek / Bank Draf / Transaksi Bank</td>
                                    <td>Amaun (RM)</td>
                                    <!-- <td>
                                        <w-icon class="mr1" @click="addBayar"
                                            >fal fa-plus</w-icon
                                        >
                                    </td> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in form.cara_bayaran">
                                    <!-- <tr> -->
                                    <td>
                                        <z-lookup
                                            :url="
                                                service_utiliti +
                                                'lookup/cara_bayar_kaunter'
                                            "
                                            :sort="false"
                                            :cache="false"
                                            v-model="d.lkp_cara_bayaran_id"

                                            required
                                            :validators="[validators.required]"
                                        />
                                        
                                    </td>
                                    <td>

                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_bank  == 1" >
                                            <z-lookup
                                                :url="
                                                    service_utiliti +
                                                    'lookup/bank'
                                                "
                                                :sort="false"
                                                :cache="false"
                                                v-model="d.lkp_bank_id"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                            />
                                        </template>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_dokumen  == 1" >
                                            <w-input
                                                class="mb4"
                                                v-model="d.no_dokumen"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                                
                                            />
                                        </template>
                                        </template>
                                    </td>
                                    <td align="right" >
                                        <!-- <z-money
                                            v-model:originalValue="d.amaun"
                                            required
                                            v-on:keyup="cekAmaunBayar(d)"
                                            validators="[validators.required]"
                                        /> -->
                                        {{ $zutil.currency(d.amaun) }}
                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_terminal  == 1" >
                                        <w-button v-if="terminal && terminal.ip_address && d.lkp_cara_bayaran_id && d.lkp_cara_bayaran_id != 4 && hantarTerminal == 1"
                                            class="my1 "
                                            @click="sendTerminal(d)">
                                            Hantar Terminal
                                        </w-button><br>
                                        </template>
                                        </template>
                                        <span class="w-form-el__error error w-form-el__error w-form-el__error">{{error_termilan}}</span>
                                        
                                    </td>
                                    <!-- <td>
                                        <w-icon
                                            class="mr1"
                                            @click="removeBayar(index)"
                                            >fal fa-trash</w-icon
                                        >
                                    </td> -->
                                </tr>
                                <tr>
                                    <td colspan="3" align="right">
                                        Jumlah (RM)
                                    </td>
                                    <td align="right">
                                        <b>
                                            {{
                                                $zutil.currency(
                                                    form.amaun
                                                )
                                            }}
                                        </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" align="right">
                                        Jumlah Perlu Dibayar(RM)
                                    </td>
                                    <td align="right">
                                        <b>{{
                                                $zutil.currency(
                                                    form.amaun
                                                )
                                            }} </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" align="right">
                                        Baki(RM)
                                    </td>
                                    <td align="right">
                                        <b>0.00</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>
            </z-page>

            <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <template v-if="$zutil.can('Terimaan Simpan') || 1">
                    <!-- <w-button
                        class="my1"
                        type="submit"
                        :disabled="form.valid === false"
                        :loading="form.submitted && !form.sent"
                    >
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                        Hantar
                    </w-button> -->
                    <template v-if="form.amaun != null && form.amaun != 0">
                          <!-- <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.loading && !form.sent" >
                            <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                                Hantar
                        </w-button>  -->
                        <w-button
                              class="my1"
                              type="submit"
                              :disabled="form.valid === false || form.loading"
                              :loading="form.loading"
                            >
                              <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                              Hantar
                            </w-button>
                    </template>
                </template>
            </w-flex>
        </w-form>

        <w-dialog
            v-model="dialogProfil.show"
            :fullscreen="dialogProfil.fullscreen"
            :width="dialogProfil.width"
            :persistent="dialogProfil.persistent"
            :persistent-no-animation="dialogProfil.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
            </template>
            <div class="page-wrapper-portal">
                <w-flex justify-center align-center>
                    <div class="xs8">
                        <w-input
                            label="No KP | Nama (Carian minimun 2 aksara)"
                            v-model="carian_profil.q"
                        >
                        </w-input>
                    </div>
                    <div class="xs4">
                        <w-button class="ml1" @click="cariProfil"
                            >Cari</w-button
                        >
                    </div>
                </w-flex>
                <div class="table-profil-scrol">
                    <table class="w-table">
                        <thead>
                            <tr>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    No
                                </th>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    No KP | Nama
                                </th>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Pilih
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in profils">
                                <td class="w-table__cell text-left">
                                    {{ index + 1 }}
                                </td>
                                <td class="w-table__cell">
                                    {{ dt.label }}
                                </td>
                                <td class="w-table__cell text-right">
                                    <w-radio
                                        class="mr2"
                                        v-model="form.profil_id"
                                        :return-value="dt.value"
                                        @click="pilihProfil(dt)"
                                    ></w-radio>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogProfil.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

        <w-dialog
            v-model="dialogProfilhm.show"
            :fullscreen="dialogProfilhm.fullscreen"
            :width="dialogProfilhm.width"
            :persistent="dialogProfilhm.persistent"
            :persistent-no-animation="dialogProfilhm.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
            </template>
            <div class="page-wrapper-portal">
                <w-flex justify-center align-center>
                    <div class="xs8">
                        <w-input
                            label="No. KP | Nama | No. Hakmilik | No. Lot | No. Bil (Carian minimun 2 aksara)"
                            v-model="carian_profil_hm.q"
                        >
                        </w-input>
                    </div>
                    <div class="xs4">
                        <w-button class="ml1" 
                    :loading="dialog.loading" @click="cariProfilhm"
                            >Cari</w-button
                        >
                    </div>
                </w-flex>
                <br /><br />
                <div class="table-profil-scrol">
                    <z-page title="Butiran Bayaran (Cukai)">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Lot/ No. PT
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_akaun"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in draf_akaun">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.profil_nama }}
                                    </td>
                                    <!-- <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.no_hm }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.no_lot }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.amaun) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_akaun"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </z-page>
                    <br /><br />

                    <z-page title="Butiran Bayaran (Bil Pelbagai)">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_inbois"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in draf_inbois">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{dt.profil_no}} | {{ dt.profil_nama }}
                                    </td>
                                    <!--  <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.no_inbois }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.amaun) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_inbois" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_inbois" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_inbois"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </z-page>
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="hantarRujukan"
                    >Hantar</w-button
                >
                &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogProfilhm.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

       
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            pilih_akaun: false,
            pilih_inbois: false,
            halangan : null,
            resourceurl: this.service_kutipan + "terimaan",
            reload: true,
            hm_cukai: [],
            butiran: [{
                akuan_id : null,
                keterangan : null,
                amaun : 0.00
            }
            ],
            error_termilan : null,
            // form_cari : [],
            form: {
              valid: false,
              errorsCount: 0,
              loading: false,
              sent: false,
              amaun: null,
              manual: 0,
            },

            form_cari: {},
            form_carian: {},
            dt_vot :{},
            amaun_bayaran: 0,
            amaun_butiran: 0,
            vot_ids : [],
            cukai: [],
            butir: [],
            draf_akaun: [],
            draf_inbois: [],
            amaun_jumlah_cukai: 0,
            form_profil: {},
            form_cari: {},
            carian_profil: { q: "" },
            profils: [],
            kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],
            hantarTerminal : 1,
            loading : false,
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                form: { nama: "", email: "" },
            },

            dialogButiran: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                butir: [],
            },
            connection: null,
            form_profil_hm: {},
            carian_profil_hm: { q: "" },
            profils: [],
            dialogProfilhm: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                pilih_akaun: false,
                pilih_inbois: false,
                form: { nama: "", email: "" },
            },
            terimaan : {},
            terminal : {},
            cara_bayaran : [],
            bank : [],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Terimaan Tanpa Bil", route: "/kutipan/terimaan/tanpa_bil" },
            ],
        };
    },
    
    created: function() {
        
        

    },

    methods: {

        sendTerminal(d) {
            if(this.terminal && this.terminal.ip_address){
                console.log(this.connection);
                if ( !this.connection ) {
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                    if ( !this.connection ) {
                        this.error_termilan = "Terminal POS tidak berjaya disambung";
                    }
                }
                if ( this.connection.readyState != 1 ) {
                    this.connection.close();
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                }
                if(this.connection.readyState == 1){
                    this.hantarTerminal = 0
                    var message = '{"type":"TXNREQ", "parameters":{"transactionType":"0200", "subTranType":"00", "paymentMethod":"card", "amount":"'+d.amaun+'", "amountOther":"0.00", "reference":"'+this.terimaan.id+'"} }';
                    this.connection.send(message);
                    this.connection.onmessage = function(event) {
                      console.log(event);
                      console.log(event.data);

                    console.log(event.data);
                    console.log(event.data.parameters)
                      if(event.data.parameters){
                          d.no_dokumen = event.data.parameters.traceNo
                      }
                      if(event.parameters){
                          d.no_dokumen = event.parameters.traceNo
                      }
                    }
                }else{
                    // alert('tidak Connect');
                    this.error_termilan = "Terminal POS tidak berjaya disambung";
                }
            }
        },

        bukaKaunter() {
                this.$zcomm
                    .post(
                        this.service_kutipan + "bukakaunter",
                        {}
                    )
                    .then((res) => {
                        if (res.ind_buka != 1) {
                            this.$inertia.visit(
                            this.$route("kutipan.kaunter.buka")
                            );
                        }
                        this.terminal = res.terminal
                        this.terimaan = res.terimaan
                        this.soket()
                    });

        },

        caraBayar() {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/cara_bayar",
                        {}
                    )
                    .then((res) => {
                        
                        this.cara_bayar = res
                       
                    });

        },


        soket(){

            if(this.terminal && this.terminal.ip_address){
                console.log("Starting connection to WebSocket Server")
                this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                if ( this.connection.readyState != 1 ) {
                    this.connection.close();
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                }
                
                this.connection.onmessage = function(event) {
                  console.log(event);

                    console.log(event.data);
                    console.log(event.data.parameters)
                   for (var i in this.form.cara_bayaran) {
                    if(event.data.parameters){
                        this.form.cara_bayaran[i].no_dokumen  = event.data.parameters.traceNo
                    }
                    if(event.parameters){
                        this.form.cara_bayaran[i].no_dokumen  = event.parameters.traceNo
                    }
                   }
                }

                this.connection.onopen = function(event) {
                  console.log(event)
                  console.log("Successfully connected to the echo websocket server...")
                }
            }
        },

        show(dat) {
            this.cukai = dat.hm_cukai;
            this.modal.show = true;
        },

        // showButiran(dt) {
        //     this.butir = dt.butiran;
        //     this.modal.showButir = true;
        // },

        

        
        

        

        cekAmaun() {
            this.form.amaun = 0;
            for (var i in this.form.butiran) {
                this.form.amaun =
                    this.form.amaun + parseFloat(this.form.butiran[i].amaun);
            }
            this.form.cara_bayaran[0].amaun = this.form.amaun 
        },

        

        

       

        submitResit() {
            // if (this.$refs.form.validate()) {
            // if (this.form.valid == true) {
            //     this.$zcomm
            //         .post(this.resourceurl+'/tanpa_bil', this.form)
            //         .then((res) => {
            //             if (typeof this.onAfterAdd === "function") {
            //                 this.onAfterAdd();
            //             }

            //             this.$zutil.notify("Rekod telah berjaya dihantar");
            //             this.$inertia.visit(
            //                 this.$route("kutipan.resit.index") +
            //                     "?resit_id=" +
            //                     res
            //             );
            //         })
            //         .catch((err) => {})
            //         .finally(() => {});
            // }

            if (this.form.valid !== true || this.form.loading) return;

            this.form.loading = true; // 🔒 lock button

            this.$zcomm
                .post(this.resourceurl + '/tanpa_bil', this.form)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }

                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    this.$inertia.visit(
                        this.$route("kutipan.resit.index") +
                        "?resit_id=" + res
                    );
                })
                .catch((err) => {
                    this.$zutil.notify(
                      err?.message || "Ralat semasa menghantar rekod",
                      "error"
                    );
                })
                .finally(() => {
                    this.form.loading = false; // 🔓 unlock (kalau stay page)
                });
            // }
        },

        

        // pilihProfilhm(dt){
        //     if (dt.no_inbois) {
        //       this.form.no_rujukan = dt.id;
        //       this.form_cari.no_rujukan = dt.no_inbois;
        //     }else{
        //           this.form.no_rujukan = dt.id;
        //           this.form_cari.no_rujukan = dt.no_hm;
        //       }
        //   this.Detail();
        // },

        cekPilih() {
            for (var i in this.draf_akaun) {
                this.draf_akaun[i].pilih_akaun = this.pilih_akaun;
            }
            for (var i in this.draf_inbois) {
                this.draf_inbois[i].pilih_inbois = this.pilih_inbois;
            }
        },
        // cekPilihInbois(){
        //         for (var i in this.draf_inbois) {
        //             this.draf_inbois[i].pilih_inbois = this.pilih_inbois
        //         }
        //       },

        
        totalKenaBayar(){
           this.cekAmaunBayar(this.form.cara_bayaran[0])
        },
        reset() {
            this.carian_profil_hm = { q: "" };
            this.draf_inbois = [
                {
                    jabatan_keterangan: "",
                    no_inbois: "",
                    keluasan: "",
                    pilih_inbois: "",
                },
            ];
            this.draf_akaun = [
                {
                    jabatan_keterangan: "",
                    no_hm: "",
                    amaun: "",
                    pilih_inbois: "",
                },
            ];
        },

       profil(){
      this.dialogProfil.show = 1
    },

   
    cariProfil(){
      if(this.carian_profil.q.length > 1){
        this.$zcomm.post(this.service_bil_pelbagai+"lookup/profil", this.carian_profil, {})
        .then(res => {
          console.log(res)
            this.profils = res
          })
      }
    },

    pilihProfil(dt){
      this.form.profil_keterangan = dt.label;
      this.form_cari.id = dt.value;
      this.profilDetail();
    },
         

        poskodDetail() {
      
        this.$zcomm.get(this.service_bil_pelbagai+'lookup/lkp_poskod_detail/'+this.form_profil.lkp_poskod_id).then(res => {
                  this.form_profil.negeri = res.negeri;
                  this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                  this.form_profil.bandar = res.bandar;
                  this.form_profil.lkp_jenis_alamat_id = 1;
                });
        },

        profilDetail() {
            // alert('w234')
          
          this.$zcomm.get(this.service_bil_pelbagai+'profil/'+this.form_cari.id).then(res => {
                  this.form.profil_id = res.id;
                  this.form.no_id = res.no_id;
                  this.form.nama = res.nama;
                  this.form.alamat1 = res.alamat1;
                  this.form.alamat2 = res.alamat2;
                  this.form.alamat3 = res.alamat3;
                  this.form.poskod = res.poskod;
                  this.form.bandar = res.bandar;
                  this.form.negeri = res.negeri;
                  this.form.kategori = res.kategori;
                  
                });
          this.dialogProfil.show = false
        },
    
        submitProfil() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true


                
                    this.$zcomm.post(this.service_bil_pelbagai+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          // this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.alamat2 = res.alamat2;
                          this.form.alamat3 = res.alamat3;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                          this.form.kategori = res.kategori;
                          this.form.profil_keterangan = res.no_id+'|'+res.nama;
                            // this.$inertia.visit(this.$page.url)
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;


                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
        addItem() {
        this.form.butiran.push( {akaun_id : null, vot_id : null,keterangan : null,amaun : 0.00 });
        },

        removeItem(index) {
            this.form.butiran.splice(index, 1);
        },

        getAkauns() {
      
        this.$zcomm.get(this.service_utiliti+'lookup/akaun_akhir_vot').then(res => {
              this.akauns = res;
            });
        },

        getVots(){
           this.$zcomm.get(this.service_utiliti+'lookup/vot').then(res => {
                  this.vots = res;
                });
        },

        Vot_akaun(dt){
        
            if(dt.ind_vot_id == 0){
                dt.ind_vot_id = 1
            }else{
                dt.ind_vot_id = 0
            }
            for (var a in this.akauns) {
                if(dt.akaun_id == this.akauns[a].value){
                    dt.vot_id = this.akauns[a].vot;
                }
            }
        },
    },
    watch: {
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },

    },
    mounted() {
        this.bukaKaunter();
        this.caraBayar();
        this.getVots();
        this.getAkauns();
        this.form.cara_bayaran = [
            {
                lkp_cara_bayaran_id: null,
                lkp_bank_id: null,
                no_dokumen: null,
                amaun: null,
            },
        ];
        this.form = {
            show: true,
            cara_bayaran : [{lkp_cara_bayaran_id: null,lkp_bank_id: null,no_dokumen: null,amaun: null,}],
            butiran : [{akaun_id : null, vot_id : null,keterangan : null,amaun : 0.00 }]}


  const today = new Date()
  const localDate = new Date(today.getTime() - (today.getTimezoneOffset() * 60000))
  this.form.tarikh_bayar = localDate.toISOString().slice(0, 10)
    }

    
    };
</script>
